// import axios from 'axios';
// import toastr from 'toastr';
import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import style from "./Careers.module.css";
import "../../node_modules/slick-carousel/slick/slick.css";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Puff } from "react-loader-spinner";


const Careers = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [data, setData] = useState({});

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setMobile] = useState("");
  const [resume, setResume] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isTyping, setIsTyping] = useState(true);

  const typingSpeed = 90; // Typing speed in ms
  const pauseBetweenTexts = 1000; // Pause between texts in ms
  var texts = [
    "Careers",
    "Be a part of our SUCCESS story!..",
    "PRODUCTIVE Work Environment...",
    "GROWING Organisation....",
  ];

  useEffect(() => {
    let timeout;

    if (isTyping) {
      if (displayedText.length < texts[currentTextIndex].length) {
        timeout = setTimeout(() => {
          setDisplayedText(
            (prev) =>
              prev + texts[currentTextIndex].charAt(displayedText.length)
          );
        }, typingSpeed);
      } else {
        timeout = setTimeout(() => setIsTyping(false), pauseBetweenTexts);
      }
    } else {
      if (displayedText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev.slice(0, -1));
        }, typingSpeed);
      } else {
        setIsTyping(true);
        setCurrentTextIndex((prev) => (prev + 1) % texts.length);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayedText, isTyping, texts, currentTextIndex]);

  const form = useRef();
  // const sendDetails = async (e, data) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   // emailjs
  //   //   .sendForm(
  //   //     "service_tg6ym9p",
  //   //     "template_jb3stbm",
  //   //     form.current,
  //   //     "BPnDYCF1NQfFe7gA4"
  //   //   )
  //   //   .then(
  //   //     (result) => {
  //   //       console.log("result====>", result.text);
  //   //       if (result.text === "OK") {
  //   //         alert("Details sent successfully");
  //   //         form.current.reset();
  //   //       }
  //   //     },
  //   //     (error) => {
  //   //       console.log(error.text);
  //   //       alert("Something went wrong");
  //   //     }
  //   //   );
  //   const finalData = {
  //     name: name,
  //     email: email,
  //     phoneNumber: phoneNo,
  //     filePath: resume.name,
  //     jobTitle: data.title,
  //     jobRole: data.role_type,
  //     jobLocation: data.location,
  //     jobDescription: data.description,
  //     jobExperience: data.experience,
  //   };
  //   console.log("finalData", JSON.stringify(finalData));
  //   const formData = new FormData();
  //   function jsonBlob(obj) {
  //     return new Blob([JSON.stringify(obj)], {
  //       type: "application/json",
  //     });
  //   }
  //   formData.append("AspironJob", jsonBlob(finalData));
  //   formData.append("AspironJobFile", resume);
  //   // const config = {
  //   //   headers: {
  //   //     "Content-Type": "multipart/form-data",
  //   //   },
  //   // };
  //   try {
  //     const res = await axios.post(
  //       "https://app.adhikrit.com:8443/crm-backend-adhikrit/api/v1/Aspiron/Job/Applied",
  //       // "http://192.168.0.126:9090/crm-backend-adhikrit/api/v1/Aspiron/Job/Applied",
  //       formData
  //     );
  //     console.log("res", res);
  //     if (res.status === 200) {
  //       setIsLoading(false);
  //       setName("");
  //       setEmail("");
  //       setMobile("");
  //       setResume("");
  //       handleClose();
  //       alert("Details sent successfully");
  //     }
  //   } catch (e) {
  //     console.error("error", e);
  //   }
  // };

  const [jobs, setJobs] = useState([
    {
      title: "Java",
      location:
        "Floor 6B-C, Bizness square Building, Opposite Hitex Kaman, Hitech City Rd, Laxmi Cyber City, White fields, HITEC City, Hyderabad, Telangana 500081",
      role: "java devoloper",
    },
    {
      title: "Python",
      location:
        "Floor 6B-C, Bizness square Building, Opposite Hitex Kaman, Hitech City Rd, Laxmi Cyber City, White fields, HITEC City, Hyderabad, Telangana 500081",
      role: "Python devoloper",
    },
    {
      title: "React JS",
      location:
        "Floor 6B-C, Bizness square Building, Opposite Hitex Kaman, Hitech City Rd, Laxmi Cyber City, White fields, HITEC City, Hyderabad, Telangana 500081",
      role: "React JS devoloper",
    },
  ]);
  function getJobs() {
    setIsLoading(true)
    axios
      .get(
        "https://app.adhikrit.com:8443/crm-backend-adhikrit/api/v1/available/jobs"
        // "http://192.168.0.126:9090/crm-backend-adhikrit/api/v1/available/jobs"
      )
      .then((res) => {
        console.log("jobPosts=====>", res);
        if (res.data) {
          setJobs(res.data);
         
        } else {
          alert("No jobs available");
        }
      })
      .catch((err) => {
        console.error("error", err);
      });
      setIsLoading(false)
  }

  useEffect(() => {
    getJobs();
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    // slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
  };

  if (isLoading) {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "absolute",
          bottom: "0",
          right: "0",
          left: "0",
          zIndex: "1000000",
        }}
      >
        <Puff
          visible={true}
          height="80"
          width="80"
          color="#4fa94d"
          ariaLabel="puff-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    );
  }

 
  function jsonDat(obj) {
    return new Blob([JSON.stringify(obj)], {
      type: "application/json",
    });
  }

  const saveData = async (e, data) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("jobApplyForm", jsonDat({ name, email, phoneNo }));
    formData.append("resume", resume);

    try {
      const response = await axios.post(
        "http://192.168.0.184:9097/aspiron-backend-adhikrit/api/v1/saveJobApplyForm",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Response:", response.data);
      alert("Details sent successfully!");
    } catch (error) {
      console.error("Error sending details:", error);
      alert("Failed to send details. Please try again.");
    }
  };

  return (
    <div>
      <section
        id="Header"
        style={{
          backgroundColor: "rgb(255, 255, 255)",
          borderRadius: "0px 0px 50px 50px",
        }}
      >
        <div className={style.career_intro_card}>
          <div class="text-container" id="text">
            <span class="blinking-cursor">|</span>
            <h1 className={style.text_container_header}>{displayedText}</h1>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="row md-12">
          {jobs && jobs.length > 0 ? (
            <>
              <h1
                style={{
                  textAlign: "center",
                  marginTop: "2rem",
                  marginBottom: "30px",
                  color: "#02334d",
                  fontSize: "2.5rem",
                  fontFamily: "'Poppins', sans-serif",
                  // textShadow:
                  //   "2px 2px 4px rgba(0, 0, 0, 0.3), 0 0 10px #02334d",
                  letterSpacing: "2px",
                  transition: "all 0.3s ease",
                }}
                // onMouseEnter={(e) => {
                //   e.target.style.textShadow =
                //     "0 0 15px #04668e, 0 0 30px #04668e, 0 0 45px #04668e";
                //   e.target.style.color = "#04668e";
                // }}
                // onMouseLeave={(e) => {
                //   e.target.style.textShadow =
                //     "2px 2px 4px rgba(0, 0, 0, 0.3), 0 0 10px #02334d";
                //   e.target.style.color = "#02334d";
                // }}
              >
                Current Openings
              </h1>

              {jobs.map((job, index) => (
                <div key={index} className="col-12 col-md-3 col-lg-4">
                  <div
                    className="card w-40 p-2 mb-3 shadow blockGradiendBg careerBlock"
                    style={{ border: "none" }}
                  >
                    <div className="card-body text-center">
                      <h5 className="card-title fw-bold mb-1">{job.title}</h5>
                      <p className="card-text mb-4">
                        <small>
                          <span>Preferred experience: {job.experience}</span>
                          <br />
                          <span>Location: {job.location}</span>
                          <br />
                          <span>Role type: {job.role}</span>
                        </small>
                      </p>
                      <form>
                        <button
                          type="button"
                          className="btn btn-sm w-100 bg-white fw-bold border-none rounded-1"
                          style={{ color: "#fd5825" }}
                          onClick={() => {
                            handleShow();
                            setData(job);
                          }}
                        >
                          <small>APPLY NOW</small>
                        </button>
                        <Modal show={show} onHide={handleClose} size="lg">
                          <Modal.Header closeButton>
                            <Modal.Title style={{ color: "#000000" }}>
                              Apply Job
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="d-md-flex justify-content-around align-items-start">
                              <div style={{ color: "#000000", width: "50%" }}>
                                <div className="mb-5">
                                  <h1>{data.title}</h1>
                                  <p>{data.description}</p>
                                  <p>
                                    Preferred experience:{" "}
                                    <span>{data.experience}</span>
                                  </p>
                                  <p>
                                    Location: <span>{data.location}</span>
                                  </p>
                                  <p>
                                    Role type: <span>{data.role}</span>
                                  </p>
                                </div>
                              </div>
                              <form
                                ref={form}
                                onSubmit={(e) => saveData(e, data)}
                                style={{ color: "#000000" }}
                              >
                                <div className={style.form_group}>
                                  <label>Name</label>
                                  <input
                                    value={name}
                                    name="name"
                                    type="text"
                                    placeholder="Name"
                                    onChange={(e) => setName(e.target.value)}
                                  />
                                </div>
                                <div className={style.form_group}>
                                  <label>Email</label>
                                  <input
                                    name="email"
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                  />
                                </div>
                                <div className={style.form_group}>
                                  <label>Mobile Number</label>
                                  <input
                                    name="mobile"
                                    type="text"
                                    placeholder="Mobile Number"
                                    value={phoneNo}
                                    onChange={(e) => setMobile(e.target.value)}
                                  />
                                </div>
                                <div className={style.form_group}>
                                  <label>Upload your Resume</label>
                                  <input
                                    onChange={(e) =>
                                      setResume(e.target.files[0])
                                    }
                                    name="resume"
                                    type="file"
                                    placeholder="Resume"
                                  />
                                </div>
                                <button
                                  type="submit"
                                  className="btn btn-primary mt-3 w-100"
                                >
                                  Send Your Details
                                </button>
                              </form>
                            </div>
                          </Modal.Body>
                          <Modal.Footer></Modal.Footer>
                        </Modal>
                      </form>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <h1
              style={{
                textAlign: "center",
                marginTop: "5rem",
                marginBottom: "35px",
                color: "black",
              }}
            >
              Currently Jobs available...
            </h1>
          )}
        </div>
      </div>

      <div
        className="container-fluid p-0"
        style={{ marginTop: "1%", textAlign: "left" }}
      >
        <section
          id="testimonials"
          style={{
            background: "#FF9800",
            padding: "10px",
            margin: "0px",
          }}
        >
          <header className="section-header text-center">
            <p style={{ fontSize: "25px", color: "black" }}>
              <strong>What our employees are saying</strong>
            </p>
          </header>
          <div
            id="testimonial-carousel"
            className="carouselwidth carousel slide mx-auto"
            data-bs-ride="carousel"
            data-bs-interval="3800"
            style={{ maxWidth: "900px" }}
          >
            <div className={style.slider_cnt}>
              <Slider {...settings}>
                <div>
                  <div style={{ margin: "10px" }}>
                    <div
                      className="card p-4 pb-3 d-flex justify-content-center"
                      style={{ borderRadius: "20px" }}
                    >
                      <div className="card-body">
                        <p
                          className="card-text pb-5"
                          style={{
                            borderBottom:
                              "0.7px solid rgba(228, 226, 226, 0.824)",
                          }}
                        >
                          "Aspiron is an incredible workplace with a positive
                          and welcoming atmosphere. I’ve always wanted to be
                          part of a supportive and dynamic team, and I’m
                          grateful to be part of Aspiron."
                        </p>
                        <div className="row d-flex align-items-center">
                          <div className="col-md-5 mt-3">
                            <h5>S.Manikandan</h5>
                            <p>Software Developer</p>
                          </div>
                          <div className="col-md-5 d-flex justify-content-end"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    className="card p-4 pb-3 d-flex justify-content-center"
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="card-body">
                      <p
                        className="card-text pb-5"
                        style={{
                          borderBottom:
                            "0.7px solid rgba(228, 226, 226, 0.824)",
                        }}
                      >
                        "Aspiron has given me the opportunity to grow and
                        regularly assess my progress. They've helped me shape a
                        clear vision for my future and the goals I aim to
                        accomplish in the coming years."
                      </p>
                      <div className="row d-flex align-items-center">
                        <div className="col-md-5 mt-3">
                          <h5>V.Pavan Kumar</h5>
                          <p>Software Developer</p>
                        </div>
                        <div className="col-md-5 d-flex justify-content-end"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className="card p-4 pb-3 d-flex justify-content-center"
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="card-body">
                      <p
                        className="card-text pb-5"
                        style={{
                          borderBottom:
                            "0.7px solid rgba(228, 226, 226, 0.824)",
                        }}
                      >
                        “Working at Aspiron is an incredible experience. The
                        team is always willing to help, and the projects are
                        both challenging and rewarding.”
                      </p>
                      <div className="row d-flex align-items-center">
                        <div className="col-md-5 mt-3">
                          <h5>K.Venkateshwarlu</h5>
                          <p>Software Associate</p>
                        </div>
                        <div className="col-md-5 d-flex justify-content-end"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    className="card p-md-4 pb-3 d-flex justify-content-center"
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="card-body">
                      <p
                        className="card-text pb-5"
                        style={{
                          borderBottom:
                            "0.7px solid rgba(228, 226, 226, 0.824)",
                        }}
                      >
                        "I’m fortunate to be part of a dynamic team where
                        challenges are met with collaboration and innovation,
                        all working together towards a shared goal and vision."
                      </p>
                      <div className="row d-flex align-items-center">
                        <div className="col-md-5 mt-3">
                          <h5>B.Bhaskar</h5>
                          <p>Software Associate</p>
                        </div>
                        <div className="col-md-5 d-flex justify-content-end"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    className="card p-4 pb-3 d-flex justify-content-center"
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="card-body">
                      <p
                        className="card-text pb-5"
                        style={{
                          borderBottom:
                            "0.7px solid rgba(228, 226, 226, 0.824)",
                        }}
                      >
                        "Aspiron is a company that fosters creativity and
                        innovation. The work environment is incredibly
                        supportive, and the team is dedicated to helping each
                        other grow, both professionally and personally."
                      </p>
                      <div className="row d-flex align-items-center">
                        <div className="col-md-5 mt-3">
                          <h5>S.Ravi Kumar</h5>
                          <p>Software Associate</p>
                        </div>
                        <div className="col-md-5 d-flex justify-content-end"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    className="card p-4 pb-3 d-flex justify-content-center"
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="card-body">
                      <p
                        className="card-text pb-5"
                        style={{
                          borderBottom:
                            "0.7px solid rgba(228, 226, 226, 0.824)",
                        }}
                      >
                        "Being a part of Aspiron has been an amazing journey.
                        The collaborative environment and the opportunity to
                        work on innovative projects have helped me grow both
                        professionally and personally."
                      </p>
                      <div className="row d-flex align-items-center">
                        <div className="col-md-5 mt-3">
                          <h5>S.Ganesh</h5>
                          <p>Software Associate</p>
                        </div>
                        <div className="col-md-5 d-flex justify-content-end"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
          <div className="d-flex justify-content-center pt-3">
            <button
              type="button"
              data-bs-target="#testimonial-carousel"
              data-bs-slide="prev"
              style={{ background: "none", border: "none" }}
            ></button>
            <button
              type="button"
              data-bs-target="#testimonial-carousel"
              data-bs-slide="next"
              style={{ background: "none", border: "none" }}
            ></button>
          </div>
        </section>
      </div>
      <br></br>
    </div>
  );
};

export default Careers;
